import { DisplayTransactionType } from '@features/bankTransactions/enums/displayTransactionType'
import { OpenBankingTransactionType } from '@features/openBanking/enums/openBankingTransactionType'

import { Side } from '../../../../../../../enums/side'
import { getTransferType } from '../utils/getTransferType'

export const openBankingTransactionTypeMap: Record<OpenBankingTransactionType, (side: Side) => DisplayTransactionType> =
  {
    [OpenBankingTransactionType.Card]: () => DisplayTransactionType.Card,
    [OpenBankingTransactionType.CashWithdrawal]: () => DisplayTransactionType.ATM,
    [OpenBankingTransactionType.DirectDebit]: () => DisplayTransactionType.DirectDebit,
    [OpenBankingTransactionType.BankTransfer]: getTransferType,
    [OpenBankingTransactionType.Unknown]: () => DisplayTransactionType.Unknown,
    [OpenBankingTransactionType.InternalCounterEntry]: () => DisplayTransactionType.Unknown,
    [OpenBankingTransactionType.PeerToPeer]: () => DisplayTransactionType.Unknown,
  }
